const req = require.context('.', true, /\.\/[^/]+\.vue$/)

req.keys().forEach((key) => {
  const componentName = key.replace(/^.+\/([^/]+)\.vue/, '$1')
  module.exports[componentName] = req(key)
})



// WEBPACK FOOTER //
// ./src/components/loginPanel/index.js